module.exports = __webpack_public_path__ + "static/media/unreadMessage.d7391523.svg";